import { useTranslation } from 'react-i18next'

import { MENU_COUNTER_ALIASES } from '../../../constants/menu'
import { useCounters, useSubMenu } from '../../../hooks'
import { SubMenu } from '../../SubMenu'
import { MenuItems } from '../MenuItems'

import * as styles from './SecondaryMenu.module.css'

function SecondaryMenu({
  Component,
  activeItem,
  className = styles.SecondaryMenu,
}) {
  const { t } = useTranslation()

  const subMenu = useSubMenu()
  const counters = useCounters()

  return (
    <MenuItems className={className}>
      <SubMenu
        show
        Component={Component}
        count={counters?.[MENU_COUNTER_ALIASES?.[activeItem?.to]]}
        menuTitle={t(activeItem?.title)}
        subMenu={subMenu}
      />
    </MenuItems>
  )
}

export default SecondaryMenu
